import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const KorukluTenteTamiriPage = () => {
  useEffect(() => {
    document.title = 'Körüklü Tente Tamiri - İzmir Tente Tamir | Uzman Tamir Servisi';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir genelinde körüklü tente tamiri hizmeti. Körük yırtıkları, mekanizma arızaları ve tüm körüklü tente sorunlarına profesyonel çözümler. 0551 372 35 12');
    }
  }, []);

  const otherServices = [
    { title: 'Tente Tamiri', link: '/hizmetler/tente-tamiri' },
    { title: 'Mafsallı Tente Tamiri', link: '/hizmetler/mafsalli-tente-tamiri' },
    { title: 'Branda Değişimi', link: '/hizmetler/branda-degisimi' },
    { title: 'Manuel Motorlu Tente Servisi', link: '/hizmetler/manuel-motorlu-tente-servisi' }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      <div className="pt-20 md:pt-24">
        <div className="w-full h-64 md:h-96">
          <img
            src="https://public.readdy.ai/ai/img_res/c4446f613129c65ca2e009efbba4ffb2.jpg"
            alt="Körüklü Tente Tamiri"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>

      <div className="pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <nav className="text-sm text-gray-500 mb-6 mt-8">
            <Link to="/" className="hover:text-gray-900 cursor-pointer">Anasayfa</Link>
            <span className="mx-2">/</span>
            <Link to="/hizmetler" className="hover:text-gray-900 cursor-pointer">Hizmetler</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-900">Körüklü Tente Tamiri</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Körüklü Tente Tamiri
              </h1>
              
              <p className="text-base text-gray-700 mb-6 leading-relaxed">
                Körüklü tenteler, özellikle dükkan vitrinleri, cafe ve restoranların dış mekanlarında tercih edilen estetik ve fonksiyonel gölgelendirme sistemleridir. Akordeon tarzı katlanabilir yapısı sayesinde hem dekoratif hem de koruyucu bir çözüm sunar. İzmir Tente Tamir olarak, körüklü tentelerinizin tüm tamir ve bakım ihtiyaçlarına profesyonel çözümler sunuyoruz.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Körüklü Tente Nedir?</h2>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Körüklü tente, akordeon şeklinde katlanan ve genellikle sabit montaj yapılan bir tente türüdür. Dalgalı, körüklü yapısı sayesinde hem görsel çekicilik sağlar hem de su birikimini önleyerek uzun ömürlü kullanım sunar. Genellikle işletme cephelerinde, vitrin önlerinde ve giriş kapılarında kullanılır.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Körüklü Tentelerde Karşılaşılan Sorunlar</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Körüklü tenteler, yapısal özellikleri nedeniyle bazı özel sorunlarla karşılaşabilir:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Körük Kıvrımlarında Yırtılma:</strong> Katlanma noktalarında zamanla aşınma ve yırtılmalar oluşabilir.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Dikiş Çözülmeleri:</strong> Körük yapısındaki dikişler yoğun kullanımda zayıflayabilir.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Çerçeve Deformasyonu:</strong> Metal çerçevede bükülme veya kırılmalar meydana gelebilir.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Renk Solması:</strong> Güneş ışınları ve hava koşulları nedeniyle renk kaybı yaşanabilir.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Montaj Aksamlarında Gevşeme:</strong> Duvara bağlantı noktalarında gevşeme ve sökülmeler olabilir.</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Körüklü Tente Tamir Hizmetlerimiz</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                İzmir Tente Tamir olarak körüklü tenteler için sunduğumuz tamir hizmetleri:
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Körük Onarımı</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Körük kıvrımlarındaki yırtık ve delikleri özel dikişlerle onarıyoruz. Gerektiğinde körük bölümlerini yeniliyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Dikiş Takviyesi</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Zayıflamış dikişleri güçlendiriyor, çözülmüş bölümleri yeniden dikiyoruz. Endüstriyel dikiş makineleri ile dayanıklı sonuçlar elde ediyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Çerçeve Tamiri</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Bükülmüş veya kırılmış metal çerçeveleri düzeltiyor veya değiştiriyoruz. Paslanma sorunlarına da müdahale ediyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Branda Yenileme</h3>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Eski ve solmuş brandaları yeni, dayanıklı ve renkli kumaşlarla değiştiriyoruz. Geniş renk ve desen seçenekleri sunuyoruz.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Tamir Süreci</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Körüklü tente tamir sürecimiz şu adımlardan oluşur:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Yerinde İnceleme:</strong> Uzman ekibimiz tentenizi yerinde inceleyerek sorunları tespit eder</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Detaylı Rapor:</strong> Yapılması gereken işlemler ve maliyetler hakkında bilgi veririz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Hızlı Tamir:</strong> Onayınızın ardından tamir işlemini en kısa sürede tamamlarız</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Kalite Kontrolü:</strong> Tamir sonrası detaylı kontrol yaparak mükemmel sonuç garantisi veririz</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Neden Bizi Tercih Etmelisiniz?</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Uzman Kadro:</strong> Körüklü tente konusunda deneyimli teknisyenlerimiz var</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Kaliteli Malzeme:</strong> Dayanıklı ve UV korumalı kumaşlar kullanıyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Hızlı Servis:</strong> İşletmenizin aksamaması için hızlı çözümler sunuyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Uygun Fiyat:</strong> Rekabetçi ve şeffaf fiyatlandırma politikamız var</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Garanti:</strong> Tüm işlemlerimiz garanti kapsamındadır</span>
                </li>
              </ul>

              <div className="bg-gray-50 rounded-xl p-6 md:p-8 mt-8">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Hemen Teklif Alın</h2>
                <p className="text-sm md:text-base text-gray-700 mb-6">
                  Körüklü tente tamiriniz için ücretsiz keşif ve fiyat teklifi almak isterseniz bize ulaşın
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="tel:+905513723512"
                    className="px-5 py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    Telefon: 0551 372 35 12
                  </a>
                  <a
                    href={`https://wa.me/905513723512?text=${encodeURIComponent('Merhaba, izmirtentetamir.net web siteniz üzerinden yazıyorum.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-5 py-2.5 border-2 border-gray-900 hover:bg-gray-50 text-gray-900 text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    WhatsApp ile Yaz
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-lg p-6 sticky top-24">
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-4">Diğer Hizmetlerimiz</h3>
                <ul className="space-y-3">
                  {otherServices.map((service, index) => (
                    <li key={index}>
                      <Link
                        to={service.link}
                        className="block p-3 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm font-medium text-gray-900 transition-colors cursor-pointer"
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default KorukluTenteTamiriPage;